import React from 'react';

const BRANDS = [
  { name: 'ARRI', src: '/images/shop/brands/Arri.png' },
  { name: 'Blackmagic Design', src: '/images/shop/brands/Black_Magic.png' },
  { name: 'Canon', src: '/images/shop/brands/Canon.png' },
  { name: 'DJI', src: '/images/shop/brands/DJI.png' },
  { name: 'Fujifilm', src: '/images/shop/brands/Fujifilm.png' },
  { name: 'Nikon', src: '/images/shop/brands/Nikon.png' },
  { name: 'Olympus', src: '/images/shop/brands/Olympus.png' },
  { name: 'Panasonic', src: '/images/shop/brands/Panasonic.png' },
  { name: 'RED', src: '/images/shop/brands/RED.png' },
  { name: 'Sony', src: '/images/shop/brands/Sony.png' },
  { name: 'Z CAM', src: '/images/shop/brands/ZCam.png' },
];

const SupportedCameras = () => {
  return (
    <div
      style={{
        padding: '10px 48px 60px',
        background: '#000',
      }}
    >
      {/* Brand logos row */}
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexWrap: 'wrap',
          gap: '0 6px',
          maxWidth: 1200,
          margin: '0 auto',
          paddingBottom: 28,
        }}
      >
        {BRANDS.map((brand) => (
          <div
            key={brand.name}
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              height: 40,
              padding: '8px 0',
            }}
          >
            <img
              src={brand.src}
              alt={brand.name}
              style={{
                height: 38,
                width: 'auto',
                objectFit: 'contain',
                opacity: 0.85,
                filter: 'brightness(1)',
              }}
            />
          </div>
        ))}
      </div>

      {/* Divider line */}
      <div
        style={{
          maxWidth: 1000,
          margin: '0 auto',
          borderTop: '1px solid rgba(255,255,255,0.12)',
        }}
      />

      {/* Label */}
      <p
        style={{
          fontFamily: 'Montserrat, sans-serif',
          fontWeight: 400,
          fontSize: 11,
          color: 'rgba(255,255,255,0.4)',
          letterSpacing: '0.25em',
          textTransform: 'uppercase',
          textAlign: 'center',
          marginTop: 20,
          marginBottom: 0,
        }}
      >
        Supported Cameras
      </p>
    </div>
  );
};

export default SupportedCameras;
